import * as React from "react";
import { Marker } from "../../../api/EvalWorkflowApi";
import { ParamType } from "../../../api/GrammarApi";
import MarkerItem from "./MarkerItem";
import ViewportImage from "../../../component/viewer/ViewportImage";
import "./marker-list.scss";

type MarkersListProps = {
  markers: Marker[];
  paramTypesByObsTypes?: Record<string, ParamType[]>;
  images: ViewportImage[];
  obsTypes: string[];
  onMarkerEnter?: (marker: Marker) => void;
  onMarkerLeave?: (marker: Marker) => void;
  onSave?: (marker: Marker) => void;
};

function MarkerList({
  markers = [],
  onMarkerEnter,
  onMarkerLeave,
  paramTypesByObsTypes,
  onSave,
  images,
  obsTypes,
}: MarkersListProps) {
  if (markers.length < 1) {
    return null;
  }

  const markersByImage = markers.reduce((acc, marker) => {
    const imageIndex = images.findIndex((img) => img.id === marker.imageId);
    return {
      ...acc,
      [imageIndex]: [...(acc[imageIndex] || []), marker],
    };
  }, {} as { [id: string]: Marker[] });

  return (
    <div className="marker-list">
      {Object.keys(markersByImage).map((imageIndex) => (
        <div key={imageIndex}>
          <h4>Image {parseInt(imageIndex, 10) + 1}</h4>
          <ul className="marker-list-items">
            {markersByImage[imageIndex].map((marker) => (
              <MarkerItem
                marker={marker}
                key={marker._label}
                onMouseEnter={() => onMarkerEnter?.(marker)}
                onMouseLeave={() => onMarkerLeave?.(marker)}
                paramTypesByObsTypes={paramTypesByObsTypes}
                onSave={onSave}
                obsTypes={obsTypes}
              />
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default MarkerList;
